// extracted by mini-css-extract-plugin
export default {"overlayContainer":"znk_O_fIG3Fh9kv8Nh1v","closeButton":"fCG8JLqP5w5pa819DibB"};